interface Topic {
  label: string;
  hot: string;
  icon: string;
}

const topics: Topic[] = [
  { label: '4K超清', hot: '289万', icon: 'ri-4k-line' },
  { label: '蓝光画质', hot: '215万', icon: 'ri-dvd-line' },
  { label: '最新电影', hot: '198万', icon: 'ri-movie-2-line' },
  { label: '科幻巨制', hot: '176万', icon: 'ri-rocket-line' },
  { label: '华语经典', hot: '154万', icon: 'ri-vip-crown-line' },
  { label: '动作大片', hot: '142万', icon: 'ri-fire-line' },
  { label: '悬疑烧脑', hot: '128万', icon: 'ri-lightbulb-line' },
  { label: '动画推荐', hot: '115万', icon: 'ri-magic-line' },
  { label: '纪录片', hot: '97万', icon: 'ri-earth-line' },
  { label: '高清不卡', hot: '89万', icon: 'ri-speed-up-line' },
  { label: '免费播放', hot: '76万', icon: 'ri-play-circle-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 bg-primary-100/80 px-4 py-2 rounded-full mb-5">
              <i className="ri-hashtag text-primary-600 text-sm"></i>
              <span className="text-primary-700 text-xs font-medium">大家都在搜</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              热门话题
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              麻花影院影迷们最关注的热门标签与搜索排行
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic, i) => (
              <a
                key={topic.label}
                href="#cards"
                className={`group flex items-center gap-2.5 rounded-full border transition-all duration-300 hover:-translate-y-0.5 cursor-pointer ${
                  i < 3
                    ? 'bg-primary-500 border-primary-500 text-white hover:bg-primary-600 px-5 py-3'
                    : 'bg-background-50 border-background-200/70 text-foreground-700 hover:border-primary-200/70 hover:text-primary-600 px-5 py-3'
                }`}
              >
                <span className={`flex items-center justify-center w-7 h-7 rounded-full ${
                  i < 3 ? 'bg-white/20' : 'bg-secondary-100'
                }`}>
                  <i className={`${topic.icon} text-sm`}></i>
                </span>
                <span className="text-sm font-medium whitespace-nowrap">{topic.label}</span>
                <span className={`text-xs font-mono ${
                  i < 3 ? 'text-white/65' : 'text-foreground-400'
                }`}>
                  {topic.hot}
                </span>
              </a>
            ))}
          </div>

          <div className="mt-10 p-6 bg-background-100 rounded-2xl border border-background-200/70">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-search-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-foreground-900 font-semibold text-sm">找不到想看的电影？</div>
                  <div className="text-foreground-500 text-xs">试试搜索或浏览专题合集</div>
                </div>
              </div>
              <a
                href="#index"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white px-5 py-2.5 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-grid-line"></i>
                浏览专题合集
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}